export const LEAVE_CONFIRMATION_MESSAGE =
  'You have unsaved data. If you close this window, the changes will be lost. Are you sure?'

export const MFA_CODE_LENGTH = 6
